import * as React from 'react';

import { PlanType } from '@showbie-socrative/socrative-utils';
import { Decimal128 } from 'proposal-decimal';

import { translate } from '~l10n/client';
import { BillingPeriod } from '~teacher/components/PricingTable/BillingPeriod';
import { formatPrice } from '~teacher/components/PricingTable/PriceComponent/helpers';
import { useTieredPricing } from '~teacher/components/PricingTable/PriceComponent/hooks/useTieredPricing';
import { MonthPrice } from '~teacher/components/PricingTable/PriceComponent/MonthPrice';
import { PrimaryButton } from '~teacher/components/PricingTable/PrimaryButton';

import platform from '../../../../../../../shared/Platform';

interface EssentialsPriceComponentProps {
  billingPeriod: BillingPeriod;
}

export function EssentialsPriceComponent({
  billingPeriod,
}: EssentialsPriceComponentProps) {
  const isApp = platform.isWrapperApp();

  const pricesQuery = useTieredPricing({
    planType: PlanType.Essentials,
    billingPeriod,
    seatCount: 1,
  });

  if (!pricesQuery.data) {
    return null;
  }

  const {
    current: {
      [BillingPeriod.Yearly]: yearly,
      [BillingPeriod.Monthly]: monthly,
    },
  } = pricesQuery.data;

  return (
    <>
      <div className={'flex flex-row'}>
        <MonthPrice price={monthly} />
      </div>
      <EssentialsBilledAnnually billingPeriod={billingPeriod} price={yearly} />
      <div className={'text-base font-sans text-blue-900 leading-8'}>
        {translate('{0} Seat Maximum').format('1')}
      </div>
      <div className="row-start-6">
        {isApp ? null : (
          <PrimaryButton
            targetPlan={PlanType.Essentials}
            billingPeriod={billingPeriod}
          />
        )}
      </div>
    </>
  );
}

interface EssentialsBilledAnnuallyTextProps {
  price: Decimal128;
  billingPeriod: BillingPeriod;
}

function EssentialsBilledAnnually({
  price,
  billingPeriod,
}: EssentialsBilledAnnuallyTextProps) {
  if (billingPeriod === BillingPeriod.Monthly) {
    return (
      <div className={'text-base font-sans text-blue-900 leading-8'}>
        {translate('{0} Annually').format(formatPrice(price))}
      </div>
    );
  }

  if (billingPeriod === BillingPeriod.Yearly) {
    return (
      <div className={'text-base font-sans text-blue-900 leading-8'}>
        {translate('{0} Billed Annually').format(formatPrice(price))}
      </div>
    );
  }
}
